import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NhCurrentUserComponent } from './nh-current-user.component';
import { NhFullScreenComponent } from './nh-full-screen.component';
import { NhNavItemsComponent } from './nh-nav-items.component';
import { CoreModule } from '@abp/ng.core';
import { NhCurrentUserImageComponent } from './current-user-image/current-user-image.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NhLogoComponent } from './nh-logo.component';
import { NhProfileComponent } from './nh-profile/nh-profile.component';
import { NhNavItemsRoutingModule } from './nh-nav-items-routing.module';
import { PageModule } from '@abp/ng.components/page';
import { ThemeSharedModule } from '@abp/ng.theme.shared';

@NgModule({
  declarations: [NhCurrentUserComponent, NhFullScreenComponent, 
    NhNavItemsComponent, NhCurrentUserImageComponent, NhLogoComponent,
    NhProfileComponent],
  imports: [
    CoreModule.forRoot(),
    CommonModule,
    NgbDropdownModule,
    NhNavItemsRoutingModule,
    PageModule,
    ThemeSharedModule
  ],
  exports: [
    NhNavItemsComponent,
    NhLogoComponent
  ]
})
export class NhNavItemsModule { }
